const contacts = {
    phoneNumber: '+43 1 334 62 80',
    email: 'cenaze@atib.at',
    iban: 'AT601200010005695563',
    bic: 'BKAUATWW',
    zvr: '657301787'
}

export default contacts;
